export enum UploadFileError {
  FILE_SIZE_LARGER_THAN_TARGET_MAX_SIZE = "FILE_SIZE_LARGER_THAN_TARGET_MAX_SIZE",
}

/** Leading bytes of the `%PDF-` marker every real PDF begins with. */
const PDF_MAGIC = [0x25, 0x50, 0x44, 0x46, 0x2d];

/** True when `bytes` begins with the PDF magic marker. */
export function bufferLooksLikePdf(bytes: Uint8Array): boolean {
  if (bytes.length < PDF_MAGIC.length) {
    return false;
  }
  return PDF_MAGIC.every((byte, i) => bytes[i] === byte);
}

/**
 * Whether an upload must be served as a download instead of inline. Non-PDFs
 * are always forced; a PDF lacking the `%PDF-` marker is forced as unsafe.
 */
export function shouldForceAttachmentDownload(
  mimetype: string,
  bytes: Uint8Array,
): boolean {
  if (mimetype !== "application/pdf") {
    return true;
  }
  return !bufferLooksLikePdf(bytes);
}
